module.exports = __webpack_public_path__ + "aef0de529210a1298ffb37bfa362470f.svg";